import './Portal.css'

import Hero from 'features/portal/Hero'
import SearchSection from 'features/portal/SearchSection'
import DocumentSection from 'features/portal/DocumentSection'

function Portal() {
    window.scrollTo(0, 0)

    return (
        <div>
            <Hero />
            <SearchSection />
            <DocumentSection />
        </div>
    )
}

export default Portal